import { useGetAttributesList } from 'hooks/useGetAttributesList';
import { AttributeType } from 'types/create-campaign';
import { TableComponent } from 'baseComponents/TableComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { AdminErrorPage } from 'components/AdminErrorPage';
import { ColumnsType } from 'antd/es/table';

const columns: ColumnsType<AttributeType> = [
  {
    title: 'Attribute',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Type',
    dataIndex: 'attribute_type',
    key: 'type',
  },
];

export const AdminManageAttributes = () => {
  const {
    data = [],
    isLoading,
    isRefetching,
    isError,
    refetch,
    error,
  } = useGetAttributesList();

  if (isError) {
    return (
      <AdminErrorPage
        isRefetching={isRefetching}
        refetch={refetch}
        error={error.response?.data?.message || 'Error fetching users'}
      />
    );
  }

  return (
    <AdminPageWrapper>
      <TableComponent
        loading={isLoading || isRefetching}
        tableName='Manage Attributes'
        dataSource={data}
        total={data.length}
        columns={columns}
      />
    </AdminPageWrapper>
  );
};
